import { createContext } from 'react';

const CaseScheduleContext = createContext(null);
export default CaseScheduleContext;
